<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="close()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Medical Exam Certificate</h4>
</div>
<div class="modal-body">
    <additional-requirements [customerNumberId]="customerNumberId" [incidentTypeId]="incidentTypeId" (doneSaving)="cancel()"></additional-requirements>
</div>
<div class="modal-footer">
</div>